import React from "react";
import { t } from "ttag";

import { CompareFeatureBlock } from "@reactivated";

import { DropdownHeadersType } from "../../../templates/ShopTileTemplate";
import { CompareFeature } from "../CompareFeature";
import { CompareTile } from "../CompareTile";
import { BlankCompareTile } from "../CompareTile/BlankCompareTile";
import { CompareTileType } from "../ShopCompareTypes";

import styles from "./index.module.scss";

interface ICompareGridProps {
    compareTiles: CompareTileType[];
    compareFeatures: CompareFeatureBlock[];
    dropdownHeaders: DropdownHeadersType;
    handleSelectProduct?: (oldTile: number, newTile: number) => void;
    selectedProducts?: number[];
}

export const MAX_COMPARE_TILES = 3;

export const CompareGrid = (props: ICompareGridProps) => {
    const selectedCompareTiles: (CompareTileType | null)[] =
        props.selectedProducts
            ? props.selectedProducts.map(
                  (productId) =>
                      props.compareTiles.find(
                          (t) => t.compare_tile?.product === productId,
                      ) || null,
              )
            : [];
    if (selectedCompareTiles.length < MAX_COMPARE_TILES) {
        const blankCompareTiles =
            MAX_COMPARE_TILES - selectedCompareTiles.length;
        for (let i = 0; i < blankCompareTiles; i++) {
            selectedCompareTiles.push(null);
        }
    }
    return (
        <div>
            <div className={styles.headerContainer}>
                <h1>{t`Compare All Mattress Models`}</h1>
                <div className={styles.headerBanner} />
            </div>
            <div className={styles.compareTileContainer}>
                <div className={styles.compareTiles}>
                    {selectedCompareTiles.map((tile, index) =>
                        tile === null ? (
                            <BlankCompareTile
                                key={index}
                                dropdownHeaders={props.dropdownHeaders}
                                handleSelectProduct={props.handleSelectProduct}
                                selectedProducts={props.selectedProducts}
                            />
                        ) : (
                            <CompareTile
                                key={index}
                                tile={tile}
                                dropdownHeaders={props.dropdownHeaders}
                                handleSelectProduct={props.handleSelectProduct}
                                selectedProducts={props.selectedProducts}
                            />
                        ),
                    )}
                </div>
                <div className={styles.compareFeatures}>
                    <CompareFeature
                        features={props.compareFeatures}
                        compareTileFeatures={
                            selectedCompareTiles
                                .filter((t) => t !== null)
                                .map(
                                    (tile) => tile.features,
                                ) as unknown as CompareFeatureBlock[][]
                        }
                    />
                </div>
            </div>
        </div>
    );
};
